import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { FascicoloFull } from 'src/app/common/models/fascicolo/fascicolo-full';
import { PropertiesSettings } from 'src/app/core/configuration/properties-settings';
import { Esito } from '../../../models/esito';
import { SezioneEsitiFull } from '../../../models/sezioni/sezione-esiti-full';
import { EsitiDatiGeneraliComponent } from './esiti-dati-generali.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [esiti-dati-generali-update]',
  templateUrl: 'esiti-dati-generali-update-mod.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class EsitiDatiGeneraliUpdateMod {
  @Output() onReturn: EventEmitter<SezioneEsitiFull> = new EventEmitter<SezioneEsitiFull>();
  @Output() esitoMod: EventEmitter<Esito> = new EventEmitter<Esito>();
  @ViewChild('formDatiGenerali') formDatiGenerali: EsitiDatiGeneraliComponent;

  isPrd: boolean = PropertiesSettings.ID_TENANTS_PRD();

  inizializza(urlUpdateAssociativa: string, esito: Esito, idSezione: string, fascicolo: FascicoloFull, urlReadSezioneControparti: string, urlReadSezioneAltreParti: string, urlReadSezioneLegali:string) {
    if(this.isPrd) this.formDatiGenerali.inizializza(urlUpdateAssociativa, esito, idSezione, fascicolo, urlReadSezioneControparti,urlReadSezioneAltreParti, urlReadSezioneLegali);

    openModal('modalmoddatigenerali');
  }

  createForm() {
    if(this.isPrd) this.formDatiGenerali.createForm();
  }

  manageModal(sezione: SezioneEsitiFull) {
      closeModal('modalmoddatigenerali');
      this.onReturn.emit(sezione);
  }

  getEsitoMod(esito: Esito){
    this.esitoMod.emit(esito);
  }
}
